export default {
  loadingGenerateUrl: false,
  generateUrlFailed: false,
  generateUrlSuccess: false,
  generatedUrl: '',
};



// WEBPACK FOOTER //
// ./src/store/modules/publishing/state.js